export const ProductDashboardFormName = "ProductDashboard";
export const TacticalPartsFormName = "TacticalParts";
export const PartsPerPageFormName = "PartPerPage";
export const MissedSalesFormName = "MissedSales";
export const DashboardExportFormName = "DashboardExport";
export const NewPartFormName = "NewPart";
